function buildAnimatedText(root = document) {
  root.querySelectorAll('[data-animated-text]').forEach((element) => {
    if (element.dataset.animatedTextBuilt === 'true') return;

    let charIndex = 0;

    element.querySelectorAll('[data-animated-text-line]').forEach((line) => {
      const content = (line.textContent || '').replace(/\n/g, '');
      const characters = Array.from(content);

      line.textContent = '';

      if (!characters.length) {
        const emptyChar = document.createElement('span');
        emptyChar.className = 'animated-text__char';
        emptyChar.setAttribute('aria-hidden', 'true');
        emptyChar.style.setProperty('--char-index', charIndex);
        emptyChar.textContent = '\u00A0';
        line.appendChild(emptyChar);
        charIndex += 1;
        return;
      }

      characters.forEach((character) => {
        const charNode = document.createElement('span');
        charNode.className = 'animated-text__char';
        charNode.setAttribute('aria-hidden', 'true');
        charNode.style.setProperty('--char-index', charIndex);
        charNode.textContent = character === ' ' ? '\u00A0' : character;
        line.appendChild(charNode);
        charIndex += 1;
      });
    });

    element.dataset.animatedTextBuilt = 'true';
  });
}

if (!window.__animatedTextSectionInitialized) {
  document.addEventListener('DOMContentLoaded', () => buildAnimatedText());

  document.addEventListener('shopify:section:load', (event) => {
    buildAnimatedText(event.target);
  });

  window.__animatedTextSectionInitialized = true;
}